module.exports = __webpack_public_path__ + "img/gift.63d6b5d6.png";